import type { User } from '../types/userMaintenance';

export const mockUsers: User[] = [
  {
    id: '1',
    username: 'kpmg2.cd.adalem',
    firstName: 'Charles David',
    middleName: 'E',
    lastName: 'Adalem',
    email: 'ceadalem@kpmg.com',
    status: 'active',
    createdAt: new Date('2024-01-15'),
    lastLogin: new Date('2025-01-16'),
    securityQuestion: 'What is your last name?',
    groupName: 'Frontliner',
    accessLevel: 'Frontliner',
    permissionLevel: 'Full Access'
  },
  {
    id: '2',
    username: 'kpmg.c.adalem',
    firstName: 'Charles David',
    middleName: 'E',
    lastName: 'Adalem',
    email: 'charles.adalem2@kpmg.com',
    status: 'active',
    createdAt: new Date('2024-02-10'),
    lastLogin: new Date('2025-01-15'),
    securityQuestion: 'What is your mother\'s maiden name?',
    groupName: 'Administrator',
    accessLevel: 'Administrator',
    permissionLevel: 'Full Access'
  },
  {
    id: '3',
    username: 'alvin.bolastig',
    firstName: 'Alvin',
    middleName: 'P',
    lastName: 'Bolastig',
    email: 'alvin.bolastig@company.com',
    status: 'active',
    createdAt: new Date('2024-03-05'),
    lastLogin: new Date('2025-01-14'),
    securityQuestion: 'What city were you born in?',
    groupName: 'Supervisor',
    accessLevel: 'Supervisor',
    permissionLevel: 'Limited Access'
  },
  {
    id: '4',
    username: 'nina.brilleta',
    firstName: 'Nina',
    middleName: '-',
    lastName: 'Brilleta',
    email: 'nina.brilleta@company.com',
    status: 'active',
    createdAt: new Date('2024-04-20'),
    lastLogin: new Date('2025-01-16'),
    securityQuestion: 'What is your favorite color?',
    groupName: 'Developer',
    accessLevel: 'Developer',
    permissionLevel: 'Full Access'
  },
  {
    id: '5',
    username: 'GDRIB',
    firstName: 'Gotuaco Del Rosario',
    middleName: 'Insurance',
    lastName: 'Brokers',
    email: 'contact@gdrib.com',
    status: 'active',
    createdAt: new Date('2024-05-12'),
    lastLogin: new Date('2025-01-13'),
    securityQuestion: 'What is your company name?',
    groupName: 'Partner',
    accessLevel: 'Partner',
    permissionLevel: 'Limited Access'
  },
  {
    id: '6',
    username: 'admin',
    firstName: 'Yumi',
    middleName: 'D',
    lastName: 'Constante',
    email: 'yumi.constante@admin.com',
    status: 'active',
    createdAt: new Date('2024-01-01'),
    lastLogin: new Date('2025-01-16'),
    securityQuestion: 'What is your pet\'s name?',
    groupName: 'Administrator',
    accessLevel: 'Administrator',
    permissionLevel: 'Full Access'
  },
  {
    id: '7',
    username: 'AITC',
    firstName: 'Travel',
    middleName: 'Asia International',
    lastName: 'Corporation',
    email: 'contact@aitc.com',
    status: 'active',
    createdAt: new Date('2024-06-08'),
    lastLogin: new Date('2025-01-12'),
    securityQuestion: 'What is your business type?',
    groupName: 'Corporate',
    accessLevel: 'Corporate',
    permissionLevel: 'Limited Access'
  },
  {
    id: '8',
    username: 'kpmg.gael.cura',
    firstName: 'Armand Gael Andrei',
    middleName: 'L',
    lastName: 'Cura',
    email: 'gael.cura@kpmg.com',
    status: 'active',
    createdAt: new Date('2024-07-15'),
    lastLogin: new Date('2025-01-11'),
    securityQuestion: 'What is your middle name?',
    groupName: 'Analyst',
    accessLevel: 'Analyst',
    permissionLevel: 'Read Only'
  },
  {
    id: '9',
    username: 'kpmg2.aga.cura',
    firstName: 'Armand Gael Andrei',
    middleName: 'L',
    lastName: 'Cura',
    email: 'aga.cura@kpmg.com',
    status: 'active',
    createdAt: new Date('2024-08-22'),
    lastLogin: new Date('2025-01-10'),
    securityQuestion: 'What is your favorite food?',
    groupName: 'Analyst',
    accessLevel: 'Analyst',
    permissionLevel: 'Read Only'
  },
  {
    id: '10',
    username: 'abd',
    firstName: 'Alice',
    middleName: 'B',
    lastName: 'Donato',
    email: 'alice.donato@company.com',
    status: 'active',
    createdAt: new Date('2024-09-18'),
    lastLogin: new Date('2025-01-09'),
    securityQuestion: 'What is your birthdate?',
    groupName: 'Support',
    accessLevel: 'Support',
    permissionLevel: 'Limited Access'
  },
  {
    id: '11',
    username: 'john.smith',
    firstName: 'John',
    middleName: 'M',
    lastName: 'Smith',
    email: 'john.smith@company.com',
    status: 'active',
    createdAt: new Date('2024-10-05'),
    lastLogin: new Date('2025-01-08'),
    securityQuestion: 'What is your favorite movie?',
    groupName: 'User',
    accessLevel: 'User',
    permissionLevel: 'Read Only'
  },
  {
    id: '12',
    username: 'mary.johnson',
    firstName: 'Mary',
    middleName: 'L',
    lastName: 'Johnson',
    email: 'mary.johnson@company.com',
    status: 'inactive',
    createdAt: new Date('2024-11-12'),
    lastLogin: new Date('2024-12-20'),
    securityQuestion: 'What is your hometown?',
    groupName: 'User',
    accessLevel: 'User',
    permissionLevel: 'Read Only'
  }
];